import React from "react";

const ProfileMostRecentPurchase = ({ profile }) => (
  <div className="profile-right-nav profile-most-recent-purchase">
    <h3>Most Recent Purchase</h3>
    <div>
      <img src={profile.most_recent_img} alt="Most Recent Purchase" />
      {profile.most_recent_title}
    </div>
  </div>
);

export default ProfileMostRecentPurchase;
